// src/contexts/widgetHeightContext.ts
// Provides the available content height inside a dashboard widget so charts
// can size themselves to fill the container instead of using fixed pixel heights.

import { createContext, useContext } from "react";

/**
 * The measured pixel height of the widget's content area (below the header).
 * null when not inside a widget (normal token page — charts use their own fixed heights).
 */
export const WidgetHeightContext = createContext<number | null>(null);

export const useWidgetHeight = () => useContext(WidgetHeightContext);
